"use client";

import React from "react";
import { AppLayout } from "@/components/chat/app-layout";

export function ChatLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      {children}
    </AppLayout>
  );
}
